var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-card-expand"},[_c('a',{staticClass:"btn-lg",attrs:{"href":"#!"},on:{"click":function($event){return _vm.showModal()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'expand']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }